(() => {
  if (customElements.get('free-shipping-belt')) return;

  class FreeShippingBelt extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;
      const rate = parseFloat(window.Shopify?.currency?.rate) || 1;
      // Threshold in the shopper's currency (minor units, like cart.total_price)
      this.goal = Math.round(parseFloat(d.amount) * (d.local === 'true' ? 1 : rate) * 100);
      this.currency = window.Shopify?.currency?.active || d.currency;
      this.text = this.querySelector('.fsb__text');
      this.track = this.querySelector('.fsb__track');
      this.render(parseInt(d.total, 10) || 0);

      this.onCart = (e) => {
        const p = e.promise || e.detail?.promise;
        Promise.resolve(p)
          .then((res) => {
            // Move straight away using the cart total the event already carries;
            // only fall back to fetching the cart if it isn't there
            const amt = parseFloat(res?.cart?.cost?.totalAmount?.amount);
            if (!isNaN(amt)) this.render(Math.round(amt * 100));
            else this.refresh();
          })
          .catch(() => this.refresh());
      };
      ['shopify:cart:lines-update', 'shopify:cart:discount-update', 'cart:update'].forEach((n) =>
        document.addEventListener(n, this.onCart)
      );
      this.onShow = (e) => e.persisted && this.refresh();
      window.addEventListener('pageshow', this.onShow);
    }

    disconnectedCallback() {
      ['shopify:cart:lines-update', 'shopify:cart:discount-update', 'cart:update'].forEach((n) =>
        document.removeEventListener(n, this.onCart)
      );
      window.removeEventListener('pageshow', this.onShow);
    }

    async refresh() {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
        if (cart.currency) this.currency = cart.currency;
        this.render(cart.total_price);
      } catch (_) {}
    }

    money(cents) {
      const v = cents / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: v % 1 ? 2 : 0,
          maximumFractionDigits: 2,
        }).format(v);
      } catch (_) {
        return `$${v.toFixed(v % 1 ? 2 : 0)}`;
      }
    }

    render(total) {
      const d = this.dataset;
      const left = Math.max(this.goal - total, 0);
      const real = this.goal > 0 ? Math.min(100, (total / this.goal) * 100) : 100;
      const done = left === 0;
      // Always show a little pattern so the roller has started
      const pct = done ? 100 : Math.max(6, Math.min(real, 97));
      // Engraving offset = distance the roller has travelled along the strap
      const strap = this.querySelector('.fsb__strap');
      const travel = ((strap?.offsetWidth || 0) * pct) / 100;
      this.style.setProperty('--fsb-roll', `${travel.toFixed(1)}px`);
      let msg;
      if (done) msg = d.msgDone;
      else if (total <= 0) msg = d.msgEmpty.replace('[amount]', this.money(this.goal));
      else msg = d.msgProgress.replace('[amount]', this.money(left));

      this.text.textContent = msg;
      this.style.setProperty('--fsb-p', `${pct}%`);
      this.style.setProperty('--fsb-pn', pct / 100);
      this.track.setAttribute('aria-valuenow', Math.round(real));
      this.classList.toggle('fsb--done', done);
    }
  }

  customElements.define('free-shipping-belt', FreeShippingBelt);
})();
